// NOTE .material-tooltip {display:block} must be added to css
/* eslint-disable */
(function($) {
  $.fn.tooltip2 = function(options) {
    var timeout = null,
      margin = 5;

    // Defaults
    var defaults = {
      delay: 350,
      tooltip2: '',
      position: 'bottom',
      html: false
    };

    // Remove tooltip2 from the activator
    if (options === "remove") {
      this.each(function() {
        $('#' + $(this).attr('data-tooltip2-id')).remove();
        $(this).removeAttr('data-tooltip2-id');
        $(this).off('mouseenter.tooltip2 mouseleave.tooltip2');
      });
      return false;
    }

    options = $.extend(defaults, options);

    return this.each(function() {
      var tooltip2Id = Materialize.guid();
      var origin = $(this);

      // Destroy old tooltip2
      if (origin.attr('data-tooltip2-id')) {
        $('#' + origin.attr('data-tooltip2-id')).remove();
      }

      origin.attr('data-tooltip2-id', tooltip2Id);

      // Get attributes.
      var allowHtml, tooltip2Delay, tooltip2Position, tooltip2Text, tooltip2El, backdrop;
      var setAttributes = function() {
        allowHtml = origin.attr('data-html') ? origin.attr('data-html') === 'true' : options.html;
        tooltip2Delay = origin.attr('data-delay');
        tooltip2Delay = tooltip2Delay === undefined || tooltip2Delay === '' ? options.delay : tooltip2Delay;
        tooltip2Position = origin.attr('data-position');
        tooltip2Position = tooltip2Position === undefined || tooltip2Position === '' ? options.position : tooltip2Position;
        tooltip2Text = origin.attr('data-tooltip2');
        tooltip2Text = tooltip2Text === undefined || tooltip2Text === '' ? options.tooltip2 : tooltip2Text;
      };
      setAttributes();







      var rendertooltip2El = function() {
        var tooltip2 = $('<div class="material-tooltip"></div>');

        // Create Text span
        if (allowHtml) {
          tooltip2Text = $('<span></span>').html(tooltip2Text);
        } else {
          tooltip2Text = $('<span></span>').text(tooltip2Text);
        }


var tooltipArrowPos;
      switch(tooltip2Position) {
      case 'left':
          tooltipArrowPos = 'right';
          break;
      case 'right':
          tooltipArrowPos = 'left';
          break;
      case 'top':
          tooltipArrowPos = 'down';
          break;
      case 'bottom':
          tooltipArrowPos = 'up';
          break;
       
  }
      var tooltipArrow = $('<span class="arrow-'+tooltipArrowPos+'-tooltip"></span>');
        // Create tooltip2
        tooltip2.append(tooltip2Text,tooltipArrow).appendTo($('body')).attr('id', tooltip2Id);

        // Create backdrop
        backdrop = $('<div class="backdrop"></div>');
        backdrop.appendTo(tooltip2);
        return tooltip2;
      };








      tooltip2El = rendertooltip2El();

      // Destroy previously binded events
      origin.off('mouseenter.tooltip2 mouseleave.tooltip2');
      // Mouse In
      var started = false,
        timeoutRef;
      origin.on({
        'mouseenter.tooltip2': function(e) {
          var showtooltip2 = function() {
            setAttributes();
            started = true;
            tooltip2El.velocity('stop');
            backdrop.velocity('stop');
            tooltip2El.css({ visibility: 'visible', left: '0px', top: '0px' });

            // tooltip2 positioning
            var originWidth = origin.outerWidth();
            var originHeight = origin.outerHeight();
            var tooltip2Height = tooltip2El.outerHeight();
            var tooltip2Width = tooltip2El.outerWidth();
            var tooltip2VerticalMovement = '0px';
            var tooltip2HorizontalMovement = '0px';
            var backdropOffsetWidth = backdrop[0].offsetWidth;
            var backdropOffsetHeight = backdrop[0].offsetHeight;
            var scaleXFactor = 8;
            var scaleYFactor = 8;
            var scaleFactor = 0;
            var targetTop, targetLeft, newCoordinates;

            if (tooltip2Position === "top") {
              // Top Position
              targetTop = origin.offset().top - tooltip2Height - margin;
              targetLeft = origin.offset().left + originWidth / 2 - tooltip2Width / 2;
              newCoordinates = repositionWithinScreen(targetLeft, targetTop, tooltip2Width, tooltip2Height);
              tooltip2VerticalMovement = '-10px';
              backdrop.css({
                bottom: 0,
                left: 0,
                borderRadius: '14px 14px 0 0',
                transformOrigin: '50% 100%',
                marginTop: tooltip2Height,
                marginLeft: tooltip2Width / 2 - backdropOffsetWidth / 2
              });
            }
            // Left Position
            else if (tooltip2Position === "left") {
              targetTop = origin.offset().top + originHeight / 2 - tooltip2Height / 2;
              targetLeft = origin.offset().left - tooltip2Width - margin;
              newCoordinates = repositionWithinScreen(targetLeft, targetTop, tooltip2Width, tooltip2Height);

              tooltip2HorizontalMovement = '-10px';
              backdrop.css({
                top: '-7px',
                right: 0,
                width: '14px',
                height: '14px',
                borderRadius: '14px 0 0 14px',
                transformOrigin: '95% 50%',
                marginTop: tooltip2Height / 2,
                marginLeft: tooltip2Width
              });
            }
            // Right Position
            else if (tooltip2Position === "right") {
              targetTop = origin.offset().top + originHeight / 2 - tooltip2Height / 2;
              targetLeft = origin.offset().left + originWidth + margin;
              newCoordinates = repositionWithinScreen(targetLeft, targetTop, tooltip2Width, tooltip2Height);

              tooltip2HorizontalMovement = '+10px';
              backdrop.css({
                top: '-7px',
                left: 0,
                width: '14px',
                height: '14px',
                borderRadius: '0 14px 14px 0',
                transformOrigin: '5% 50%',
                marginTop: tooltip2Height / 2,
                marginLeft: '0px'
              });
            } else {
              // Bottom Position
              targetTop = origin.offset().top + origin.outerHeight() + margin;
              targetLeft = origin.offset().left + originWidth / 2 - tooltip2Width / 2;
              newCoordinates = repositionWithinScreen(targetLeft, targetTop, tooltip2Width, tooltip2Height);
              tooltip2VerticalMovement = '+10px';
              backdrop.css({
                top: 0,
                left: 0,
                marginLeft: tooltip2Width / 2 - backdropOffsetWidth / 2
              });
            }

            // Set tooptip css placement
            tooltip2El.css({
              top: newCoordinates.y,
              left: newCoordinates.x
            });

            // Calculate Scale to fill
            scaleXFactor = Math.SQRT2 * tooltip2Width / parseInt(backdropOffsetWidth);
            scaleYFactor = Math.SQRT2 * tooltip2Height / parseInt(backdropOffsetHeight);
            scaleFactor = Math.max(scaleXFactor, scaleYFactor);

            tooltip2El.velocity({ translateY: tooltip2VerticalMovement, translateX: tooltip2HorizontalMovement }, { duration: 350, queue: false }).velocity({ opacity: 1 }, { duration: 300, delay: 50, queue: false });
            backdrop.css({ visibility: 'visible' }).velocity({ opacity: 1 }, { duration: 55, delay: 0, queue: false }).velocity({ scaleX: scaleFactor, scaleY: scaleFactor }, { duration: 300, delay: 0, queue: false, easing: 'easeInOutQuad' });
          };

          timeoutRef = setTimeout(showtooltip2, tooltip2Delay); // End Interval

          // Mouse Out
        },
        'mouseleave.tooltip2': function() {
          // Reset State
          started = false;
          clearTimeout(timeoutRef);

          // Animate back
          setTimeout(function() {
            if (started !== true) {
              tooltip2El.velocity({
                opacity: 0,
                translateY: 0,
                translateX: 0
              }, { duration: 225, queue: false });
              backdrop.velocity({ opacity: 0, scaleX: 1, scaleY: 1 }, {
                duration: 225,
                queue: false,
                complete: function() {
                  backdrop.css({ visibility: 'hidden' });
                  tooltip2El.css({ visibility: 'hidden' });
                  started = false;
                }
              });
            }
          }, 225);
        }
      });
    });
  };

  var repositionWithinScreen = function(x, y, width, height) {
    var newX = x;
    var newY = y;

    if (newX < 0) {
      newX = 4;
    } else if (newX + width > window.innerWidth) {
      newX -= newX + width - window.innerWidth;
    }

    if (newY < 0) {
      newY = 4;
    } else if (newY + height > window.innerHeight + $(window).scrollTop) {
      newY -= newY + height - window.innerHeight;
    }

    return { x: newX, y: newY };
  };

  // $(document).ready(function() {
  //   $('.tooltip2').tooltip2();
  // });
})(jQuery);